import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { UserService } from 'src/app/admin/services/user.service';

@Component({
  selector: 'app-admin-settings-page',
  templateUrl: './admin-settings.page.html',
  styleUrls: ['./admin-settings.page.scss'],
})

export class AdminSettingsPage implements OnInit {

  loggedUser$ = this.accountService.currentUser$;

  resetPassword = {
    oldPassword: '',
    password: '',
    confirmPassword: ''
  }

  msg = '';

  constructor(private accountService: AccountService, private userService: UserService, private route: Router) {}

  ngOnInit(): void {}

  changePassword() {
    this.userService.changePassword(this.resetPassword).subscribe(res => {
      this.msg = 'Lozinka uspešno promenjena.'
      this.resetPassword = {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      }
    })
  }

  logout() {
    this.accountService.logout();
    this.route.navigateByUrl('admin/login')
  }
}
